import { call, put, takeEvery } from "redux-saga/effects";
import {
  getCampaignCustomNamesList,
  hideCampaignCustomNamesListLoader, setCampaignCustomNameProfile,
  setCampaignCustomNamesList, setErrorCampaignCustomNameProfile,
  showCampaignCustomNamesListLoader
} from "./actions";
import {
  ADD_CAMPAIGN_CUSTOM_NAMES,
  DELETE_CAMPAIGN_CUSTOM_NAMES,
  GET_CAMPAIGN_CUSTOM_NAME_PROFILE,
  GET_CAMPAIGN_CUSTOM_NAMES_LIST,
  UPDATE_CAMPAIGN_CUSTOM_NAME_PROFILE
} from "./actionTypes";
import {
  deleteCampaignCustomNames,
  getCampaignCustomNames,
  getCampaignCustomNamesProfile,
  postCampaignCustomNames,
  putCampaignCustomNamesProfile
} from "../../../helpers/jwt_helper";
import { getErrorMessage, showErrorMessage, showSuccessMessage } from "../../../helpers/utils";

// Chat Redux States
function* onGetCampaignCustomNamesList({ payload: data }) {
  try {
    yield put(showCampaignCustomNamesListLoader());
    let response = yield call(getCampaignCustomNames, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search
    });
    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({ ...i, description: i.description === "string" ? "" : i.description }))
    };
    yield put(setCampaignCustomNamesList(response));
    yield put(hideCampaignCustomNamesListLoader());
  } catch (error) {
    yield put(hideCampaignCustomNamesListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddCampaignCustomNames({ payload: {customName, data } }) {
  try {
    yield put(showCampaignCustomNamesListLoader());
    yield call(postCampaignCustomNames, {
      name: customName.name,
      description: customName.description
    });
    yield call(onGetCampaignCustomNamesList, { payload: data });
    yield put(hideCampaignCustomNamesListLoader());
    showSuccessMessage("Campaign's custom name has been added");
  } catch (error) {
    yield put(hideCampaignCustomNamesListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onDeleteCampaignCustomNames({ payload: { id, data } }) {
  try {
    yield put(showCampaignCustomNamesListLoader());
    yield call(deleteCampaignCustomNames, id);
    yield call(onGetCampaignCustomNamesList, { payload: data });
    yield put(hideCampaignCustomNamesListLoader());
    showSuccessMessage("Campaign custom name has been deleted");
  } catch (error) {
    yield put(hideCampaignCustomNamesListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetCampaignCustomNameProfile({ payload: id }) {
  try {
    yield put(setErrorCampaignCustomNameProfile(false));
    let response = yield call(getCampaignCustomNamesProfile, id);
    yield put(setCampaignCustomNameProfile(response));
  } catch (error) {
    if (getErrorMessage(error) === 'Not found.') {
      yield put(setErrorCampaignCustomNameProfile(true));
    } else {
      showErrorMessage(getErrorMessage(error));
    }
  }
}

function* onUpdateCampaignCustomNameProfile({ payload: {id, customName, data } }) {
  try {
    yield put(showCampaignCustomNamesListLoader());
    yield call(putCampaignCustomNamesProfile, id, {
      name: customName.name,
      description: customName.description
    });
    yield call(onGetCampaignCustomNamesList, { payload: data });
    yield put(hideCampaignCustomNamesListLoader());
    showSuccessMessage("Campaign custom name has been updated");
  } catch (error) {
    yield put(hideCampaignCustomNamesListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* campaignCustomNamesListSaga() {
  yield takeEvery(GET_CAMPAIGN_CUSTOM_NAMES_LIST, onGetCampaignCustomNamesList);
  yield takeEvery(DELETE_CAMPAIGN_CUSTOM_NAMES, onDeleteCampaignCustomNames);
  yield takeEvery(ADD_CAMPAIGN_CUSTOM_NAMES, onAddCampaignCustomNames);
  yield takeEvery(GET_CAMPAIGN_CUSTOM_NAME_PROFILE, onGetCampaignCustomNameProfile);
  yield takeEvery(UPDATE_CAMPAIGN_CUSTOM_NAME_PROFILE, onUpdateCampaignCustomNameProfile);
}

export default campaignCustomNamesListSaga;
